import { shouldDisableGridByProductColorGridFlag } from '../../../../../../utils/shouldDisableGridByProductColorGridFlag';
import {
  CombinationButtonStatusEnum,
  IGridStatus,
} from '../../../../../products/products-details-v2/hooks/useCombination';
import { getButtonStatus } from '../../../../../products/products-details-v2/hooks/useCombination.utils';
import { isInputWithError, shouldDisableProductInput } from '../../utils/productGrid.utils';
import {
  SelectCellDisabledParams,
  SelectCellErrorParams,
  SelectCellQuantityParams,
  SelectCombinationButtonStatusParams,
} from './gridStore.types';

export const selectCellQuantity = ({
  cells,
  combinationKey,
  skuId,
}: SelectCellQuantityParams): number => cells[combinationKey]?.[skuId]?.quantity ?? 0;

export const selectCellError = ({
  quantity,
  gridItem,
  availability,
  orderViewMode,
}: SelectCellErrorParams): boolean =>
  isInputWithError({
    availability,
    availableForReadyForDeliveryWithoutStock: gridItem.availableForReadyForDeliveryWithoutStock,
    quantity,
    available: gridItem.available,
    productSizeActive: !!gridItem.productSizeActive,
    orderViewMode,
  });

export const selectCellDisabled = ({
  quantity,
  gridItem,
  error,
  availability,
  allowChangePreOrderGrid,
  allowChangeImmediateGrid,
  readMode,
  disableAll,
  isOrderProductFromKit,
  orderViewMode,
}: SelectCellDisabledParams): boolean => {
  const isDisableProductColorGrid =
    allowChangeImmediateGrid !== undefined && allowChangePreOrderGrid !== undefined
      ? shouldDisableGridByProductColorGridFlag({
          availability,
          allowChangeImmediateGrid,
          allowChangePreOrderGrid,
        })
      : false;

  const isShouldDisableOrderProductGrid =
    !!disableAll || isDisableProductColorGrid || !!isOrderProductFromKit;

  if (isShouldDisableOrderProductGrid || readMode) {
    return true;
  }

  return shouldDisableProductInput({
    orderViewMode,
    availability,
    gridItem: { ...gridItem, orderItemQuantity: quantity },
    error,
  });
};

export const selectCombinationButtonStatus = ({
  cells,
  combinationKey,
  hasEmptyAvailability,
  isPending,
}: SelectCombinationButtonStatusParams): IGridStatus => {
  const combinationCells = Object.values(cells[combinationKey] ?? {});

  const grid = combinationCells.map((cell) => ({
    orderItemQuantity: cell.quantity,
    orderItemId: cell.orderItemId,
  }));

  if (isPending) {
    const storeSum = grid.reduce((sum, item) => sum + (item.orderItemQuantity ?? 0), 0);
    return { type: CombinationButtonStatusEnum.LOADING, itemQuantity: storeSum };
  }

  const status = getButtonStatus({ hasEmptyAvailability, grid });

  if (status.type !== CombinationButtonStatusEnum.ADD) {
    return status;
  }

  const hasPendingCell = combinationCells.some((cell) => cell.isPending);

  return hasPendingCell ? { ...status, type: CombinationButtonStatusEnum.ADDED } : status;
};
